import CallbackNotification from '../../assets/images/icons/CallbackNotification';
import PaymentSuccessNotification from '../../assets/images/icons/PaymentSuccessNotification';
import PtpNotification from '../../assets/images/icons/PtpNotification';
import P2P from '../../assets/images/icons/P2P';
import CustomerMissedCallNotification from '../../assets/images/icons/CustomerMissedCallNotification';
import PaymentFailedNotification from '../../assets/images/icons/PaymentFailedNotification';
import NewAddressNotification from '../../assets/images/icons/NewAddressNotification';
import ErrorIcon from '../../assets/images/icons/ErrorIcon';
import CibilAlertsIcon from 'src/assets/images/icons/CibilAlertsIcon';
import AllocationIcon from 'src/assets/images/icons/AllocationIcon';
import AmeyoCallDropIcon from 'src/assets/images/icons/AmeyoCallDropIcon';
import AmeyoCallNotPickedIcon from 'src/assets/images/icons/AmyoCallNotPickedIcon';
import RaiseRequestIcon from '@cp/src/assets/icons/RaiseRequestIcon';
import ReceiveRequestIcon from '@cp/src/assets/icons/ReceiveRequestIcon';
import FeeReappliedIcon from '@cp/src/assets/icons/FeeReappliedIcon';
import InfoNotification from '@cp/src/assets/images/icons/InfoNotification';
import AnomalyResolvedIcon from '@cp/src/assets/images/icons/AnomalyResolvedIcon';
import AnomalyDetectedIcon from '@cp/src/assets/images/icons/AnomalyDetectedIcon';
import EscalationNotifIcon from '@cp/src/assets/images/icons/EscalationNotifIcon';

export enum NotificationTypes {
  LONGHORN_NOTIFICATION = 'LONGHORN_NOTIFICATION',
  LONGHORN_ALERT = 'LONGHORN_ALERT',
  LONGHORN_POPUP = 'LONGHORN_POPUP',
  LONGHORN_STICKY_BANNER = 'LONGHORN_STICKY_BANNER',
  TRIGGER_ONLY_FCM = 'TRIGGER_ONLY_FCM'
}

export const TemplateTypes = {
  PAYMENT_MADE_TEMPLATE: 'PAYMENT_MADE_TEMPLATE',
  ENACH_PAYMENT_MADE_TEMPLATE: 'ENACH_PAYMENT_MADE_TEMPLATE',
  PROMISED_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE:
    'PROMISED_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE',
  CUSTOMER_CALLED_TEMPLATE: 'CUSTOMER_CALLED_TEMPLATE',
  PAYMENT_FAILED_TEMPLATE: 'PAYMENT_FAILED_TEMPLATE',
  ENACH_PAYMENT_FAILED_TEMPLATE: 'ENACH_PAYMENT_FAILED_TEMPLATE',
  PAYMENT_FAILED_TEMPLATE_V2: 'PAYMENT_FAILED_TEMPLATE_V2',
  REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE:
    'REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE',
  REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE: 'REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE',
  NEW_ADDRESS_ADDED_NOTIFICATION_TEMPLATE: 'NEW_ADDRESS_ADDED_NOTIFICATION_TEMPLATE',
  NEW_TELEPHONE_ADDED_NOTIFICATION_TEMPLATE: 'NEW_TELEPHONE_ADDED_NOTIFICATION_TEMPLATE',
  BUSY_SCHEDULED_NOTIFICATION_TEMPLATE: 'BUSY_SCHEDULED_NOTIFICATION_TEMPLATE',
  LONGHORN_ALERTS_NEW_ENQUIRY: 'LONGHORN_ALERTS_NEW_ENQUIRY',
  LONGHORN_ALERTS_NEW_TRADE_ACCOUNT: 'LONGHORN_ALERTS_NEW_TRADE_ACCOUNT',
  LONGHORN_ALERTS_CHANGE_IN_UTILIZATION: 'LONGHORN_ALERTS_CHANGE_IN_UTILIZATION',
  LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY_ACCOUNTS: 'LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY_ACCOUNTS',
  LONGHORN_ALERTS_NEW_PHONE_NUMBER_ADDED: 'LONGHORN_ALERTS_NEW_PHONE_NUMBER_ADDED',
  LONGHORN_ALERTS_CHANGE_IN_SCORE: 'LONGHORN_ALERTS_CHANGE_IN_SCORE',
  LONGHORN_ALERTS_MULTIPLE_TRIGGER_ALERTS: 'LONGHORN_ALERTS_MULTIPLE_TRIGGER_ALERTS',
  LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY: 'LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY',
  CASE_ALLOCATED_NOTIFICATION_TEMPLATE: 'CASE_ALLOCATED_NOTIFICATION_TEMPLATE',
  CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE: 'CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE',
  PAYMENT_MADE_TEMPLATE_V2: 'PAYMENT_MADE_TEMPLATE_V2',
  CUSTOMER_CALLED_TEMPLATE_V2: 'CUSTOMER_CALLED_TEMPLATE_V2',
  AMEYO_CALL_DROP: 'AMEYO_CALL_DROP',
  AMEYO_CALL_NOT_PICKED: 'AMEYO_CALL_NOT_PICKED',
  TELE_AGENTS_COSMOS_INACTIVITY_POPUP: 'TELE_AGENTS_COSMOS_INACTIVITY_POPUP',
  FIELD_BOT_PROMISE_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE:
    'PROMISED_TO_PAY_GEN_AI_BOT_FIELD_SCHEDULED_NOTIFICATION_TEMPLATE',
  FIELD_BOT_REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE:
    'REQUESTED_CALLBACK_GEN_AI_BOT_FIELD_SCHEDULED_NOTIFICATION_TEMPLATE',
  FIELD_BOT_REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE:
    'REVISIT_GEN_AI_BOT_SCHEDULED_NOTIFICATION_TEMPLATE',
  SUPPORT_REQUEST_RECEIVED: 'SUPPORT_REQUEST_RECEIVED',
  SUPPORT_REQUEST_RESOLVED: 'SUPPORT_REQUEST_RESOLVED',
  MESSAGE_WAIVE_UNHOLD_NOTIFICATION_TEMPLATE: 'MESSAGE_WAIVE_UNHOLD_NOTIFICATION_TEMPLATE',
  COLLECTION_PAUSE_EFFORTS_CASE_DEALLOCATED: 'COLLECTION_PAUSE_EFFORTS_CASE_DEALLOCATED',
  ANOMALY_TRACKER_DETECTION: 'ANOMALY_TRACKER_DETECTION_V2',
  ANOMALY_TRACKER_RESOLUTION: 'ANOMALY_TRACKER_RESOLUTION',
  COLLECTION_PAUSE_EFFORTS_CASE_PAUSED: 'COLLECTION_PAUSE_EFFORTS_CASE_PAUSED',
  COLLECTION_UNPAUSE_EFFORT_EVENT: 'COLLECTION_UNPAUSE_EFFORT_EVENT',
  COLLECTION_ESCALATION_RAISED: 'COLLECTION_ESCALATION_RAISED',
  WHATSAPP_CALL_INTERACTION: 'WHATSAPP_CALL_INTERACTION',
  SUBSCRIPTION_BASED_NOTIFICATION_NUDGE: 'SUBSCRIPTION_BASED_NOTIFICATION_NUDGE'
};

export const PaymentSuccessTemplateTypes = [
  TemplateTypes.PAYMENT_MADE_TEMPLATE,
  TemplateTypes.PAYMENT_MADE_TEMPLATE_V2,
  TemplateTypes.ENACH_PAYMENT_MADE_TEMPLATE
];

export const NotificationTabTypes = {
  All: 'All',
  Payments: 'Payments',
  PTPs: 'PTPs',
  Calls: 'Calls',
  Tasks: 'Tasks',
  Others: 'Others'
};

export type NotificationTabTypesKeys = keyof typeof NotificationTabTypes;
export type NotificationTabTypesValues = (typeof NotificationTabTypes)[NotificationTabTypesKeys];

export const NotificationTabTemplateMap = {
  [NotificationTabTypes.Payments]: [
    TemplateTypes.PAYMENT_MADE_TEMPLATE,
    TemplateTypes.ENACH_PAYMENT_MADE_TEMPLATE,
    TemplateTypes.PAYMENT_FAILED_TEMPLATE,
    TemplateTypes.ENACH_PAYMENT_FAILED_TEMPLATE,
    TemplateTypes.PAYMENT_MADE_TEMPLATE_V2,
    TemplateTypes.PAYMENT_FAILED_TEMPLATE_V2
  ],
  [NotificationTabTypes.PTPs]: [
    TemplateTypes.PROMISED_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.FIELD_BOT_PROMISE_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE
  ],
  [NotificationTabTypes.Calls]: [
    TemplateTypes.REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.CUSTOMER_CALLED_TEMPLATE,
    TemplateTypes.CUSTOMER_CALLED_TEMPLATE_V2,
    TemplateTypes.AMEYO_CALL_DROP,
    TemplateTypes.AMEYO_CALL_NOT_PICKED,
    TemplateTypes.FIELD_BOT_REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE
  ],
  [NotificationTabTypes.Others]: [
    TemplateTypes.NEW_TELEPHONE_ADDED_NOTIFICATION_TEMPLATE,
    TemplateTypes.LONGHORN_ALERTS_NEW_PHONE_NUMBER_ADDED,
    TemplateTypes.LONGHORN_ALERTS_NEW_TRADE_ACCOUNT,
    TemplateTypes.LONGHORN_ALERTS_NEW_ENQUIRY,
    TemplateTypes.CASE_ALLOCATED_NOTIFICATION_TEMPLATE,
    TemplateTypes.CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE,
    TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_DEALLOCATED,
    TemplateTypes.BUSY_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.FIELD_BOT_REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.MESSAGE_WAIVE_UNHOLD_NOTIFICATION_TEMPLATE,
    TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_PAUSED,
    TemplateTypes.COLLECTION_UNPAUSE_EFFORT_EVENT,
    TemplateTypes.COLLECTION_ESCALATION_RAISED
  ],
  [NotificationTabTypes.All]: [
    TemplateTypes.PAYMENT_MADE_TEMPLATE,
    TemplateTypes.ENACH_PAYMENT_MADE_TEMPLATE,
    TemplateTypes.PROMISED_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.CUSTOMER_CALLED_TEMPLATE,
    TemplateTypes.PAYMENT_FAILED_TEMPLATE,
    TemplateTypes.ENACH_PAYMENT_FAILED_TEMPLATE,
    TemplateTypes.REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.NEW_TELEPHONE_ADDED_NOTIFICATION_TEMPLATE,
    TemplateTypes.BUSY_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.LONGHORN_ALERTS_NEW_ENQUIRY,
    TemplateTypes.LONGHORN_ALERTS_NEW_TRADE_ACCOUNT,
    TemplateTypes.LONGHORN_ALERTS_NEW_PHONE_NUMBER_ADDED,
    TemplateTypes.CASE_ALLOCATED_NOTIFICATION_TEMPLATE,
    TemplateTypes.CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE,
    TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_DEALLOCATED,
    TemplateTypes.PAYMENT_FAILED_TEMPLATE_V2,
    TemplateTypes.PAYMENT_MADE_TEMPLATE_V2,
    TemplateTypes.CUSTOMER_CALLED_TEMPLATE_V2,
    TemplateTypes.REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.AMEYO_CALL_DROP,
    TemplateTypes.AMEYO_CALL_NOT_PICKED,
    TemplateTypes.FIELD_BOT_PROMISE_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.FIELD_BOT_REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.FIELD_BOT_REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE,
    TemplateTypes.SUPPORT_REQUEST_RECEIVED,
    TemplateTypes.SUPPORT_REQUEST_RESOLVED,
    TemplateTypes.MESSAGE_WAIVE_UNHOLD_NOTIFICATION_TEMPLATE,
    TemplateTypes.ANOMALY_TRACKER_DETECTION,
    TemplateTypes.ANOMALY_TRACKER_RESOLUTION,
    TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_PAUSED,
    TemplateTypes.COLLECTION_UNPAUSE_EFFORT_EVENT,
    TemplateTypes.COLLECTION_ESCALATION_RAISED,
    TemplateTypes.WHATSAPP_CALL_INTERACTION
  ],
  [NotificationTabTypes.Tasks]: [
    TemplateTypes.SUPPORT_REQUEST_RECEIVED,
    TemplateTypes.SUPPORT_REQUEST_RESOLVED
  ]
};

export const AmeyoCallNotifications = [
  TemplateTypes.AMEYO_CALL_DROP,
  TemplateTypes.AMEYO_CALL_NOT_PICKED
];

export const TemplateInfoMap = {
  [TemplateTypes.PAYMENT_MADE_TEMPLATE]: {
    label: 'Payment made',
    icon: <PaymentSuccessNotification />
  },
  [TemplateTypes.ENACH_PAYMENT_MADE_TEMPLATE]: {
    label: 'E_NACH payment made',
    icon: <PaymentSuccessNotification />
  },
  [TemplateTypes.PAYMENT_MADE_TEMPLATE_V2]: {
    label: 'Payment made',
    icon: <PaymentSuccessNotification />
  },
  [TemplateTypes.PROMISED_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Promise to pay scheduled',
    icon: <PtpNotification />
  },
  [TemplateTypes.REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Revisit scheduled',
    icon: <P2P />
  },
  [TemplateTypes.CUSTOMER_CALLED_TEMPLATE]: {
    label: 'Customer called',
    icon: <CustomerMissedCallNotification />
  },
  [TemplateTypes.CUSTOMER_CALLED_TEMPLATE_V2]: {
    label: 'Customer called',
    icon: <CustomerMissedCallNotification />
  },
  [TemplateTypes.PAYMENT_FAILED_TEMPLATE]: {
    label: 'Payment failed',
    icon: <PaymentFailedNotification />
  },
  [TemplateTypes.ENACH_PAYMENT_FAILED_TEMPLATE]: {
    label: 'E_NACH payment failed',
    icon: <PaymentFailedNotification />
  },
  [TemplateTypes.PAYMENT_FAILED_TEMPLATE_V2]: {
    label: 'Payment failed',
    icon: <PaymentFailedNotification />
  },
  [TemplateTypes.REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Requested callback',
    icon: <CallbackNotification />
  },
  [TemplateTypes.NEW_ADDRESS_ADDED_NOTIFICATION_TEMPLATE]: {
    label: 'New address added',
    icon: <NewAddressNotification />
  },
  [TemplateTypes.NEW_TELEPHONE_ADDED_NOTIFICATION_TEMPLATE]: {
    label: 'New telephone added',
    icon: <CibilAlertsIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_NEW_ENQUIRY]: { label: 'New inquiry', icon: <CibilAlertsIcon /> },
  [TemplateTypes.LONGHORN_ALERTS_NEW_TRADE_ACCOUNT]: {
    label: 'New trade account',
    icon: <CibilAlertsIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_CHANGE_IN_UTILIZATION]: {
    label: 'Change in utilization',
    icon: <ErrorIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY_ACCOUNTS]: {
    label: 'Change in delinquency accounts',
    icon: <ErrorIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_NEW_PHONE_NUMBER_ADDED]: {
    label: 'New phone number added',
    icon: <CibilAlertsIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_CHANGE_IN_SCORE]: {
    label: 'Change in score',
    icon: <ErrorIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_MULTIPLE_TRIGGER_ALERTS]: {
    label: 'Multiple trigger alerts',
    icon: <ErrorIcon />
  },
  [TemplateTypes.LONGHORN_ALERTS_CHANGE_IN_DELIQUENCY]: {
    label: 'Change in delinquency',
    icon: <ErrorIcon />
  },
  [TemplateTypes.CASE_ALLOCATED_NOTIFICATION_TEMPLATE]: {
    label: 'Case Allocated',
    icon: <AllocationIcon />
  },
  [TemplateTypes.CASE_DE_ALLOCATED_NOTIFICATION_TEMPLATE]: {
    label: 'Case De-allocated',
    icon: <AllocationIcon />
  },
  [TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_DEALLOCATED]: {
    label: 'Case De-allocated',
    icon: <InfoNotification />
  },
  [TemplateTypes.COLLECTION_PAUSE_EFFORTS_CASE_PAUSED]: {
    label: 'Case Paused',
    icon: <ErrorIcon />
  },
  [TemplateTypes.COLLECTION_UNPAUSE_EFFORT_EVENT]: {
    label: 'Case Unpaused',
    icon: <ErrorIcon />
  },
  [TemplateTypes.AMEYO_CALL_DROP]: {
    label: 'Ameyo Call Drop',
    icon: <AmeyoCallDropIcon />
  },
  [TemplateTypes.AMEYO_CALL_NOT_PICKED]: {
    label: 'Ameyo Call Not Picked',
    icon: <AmeyoCallNotPickedIcon />
  },
  [TemplateTypes.FIELD_BOT_PROMISE_TO_PAY_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Promise to pay scheduled',
    icon: <PtpNotification />
  },
  [TemplateTypes.FIELD_BOT_REQUESTED_CALLBACK_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Requested callback',
    icon: <CallbackNotification />
  },
  [TemplateTypes.FIELD_BOT_REVISIT_SCHEDULED_NOTIFICATION_TEMPLATE]: {
    label: 'Revisit scheduled',
    icon: <P2P />
  },
  [TemplateTypes.SUPPORT_REQUEST_RECEIVED]: {
    label: 'Support request received',
    icon: <ReceiveRequestIcon />
  },
  [TemplateTypes.SUPPORT_REQUEST_RESOLVED]: {
    label: 'Support request resolved',
    icon: <RaiseRequestIcon />
  },
  [TemplateTypes.MESSAGE_WAIVE_UNHOLD_NOTIFICATION_TEMPLATE]: {
    label: 'Fees reapplied',
    icon: <FeeReappliedIcon />
  },
  [TemplateTypes.ANOMALY_TRACKER_DETECTION]: {
    label: 'Anomaly detected',
    icon: <AnomalyDetectedIcon />
  },
  [TemplateTypes.ANOMALY_TRACKER_RESOLUTION]: {
    label: 'Anomaly resolved',
    icon: <AnomalyResolvedIcon />
  },
  [TemplateTypes.COLLECTION_ESCALATION_RAISED]: {
    label: 'Collection Escalation Raised',
    icon: <EscalationNotifIcon />
  },
  [TemplateTypes.WHATSAPP_CALL_INTERACTION]: {
    label: 'Whatsapp Call Interaction',
    icon: <CallbackNotification />
  }
};

export const WidgetStatuses = {
  CLICKED: 'CLICKED'
};

export const LimitAlerts = {
  CALL_ATTEMPT_LIMIT_ALERT: 'CALL_ATTEMPT_LIMIT_ALERT'
};

export const AnomalyNotificationMap = {
  [TemplateTypes.ANOMALY_TRACKER_DETECTION]: true,
  [TemplateTypes.ANOMALY_TRACKER_RESOLUTION]: true
};

export const SUBSCRIPTION_DATA_KEY = 'subscription_data';
export const SUBSCRIPTION_CASE_ID_KEY = 'subscription_case_id';
